"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EStatus = void 0;
/* eslint-disable */
//tslint:disable
let EStatus = exports.EStatus = /*#__PURE__*/function (EStatus) {
  /** Удачно **/
  EStatus["Success"] = "success";
  /** Код введён некорректно **/
  EStatus["Wrong"] = "wrong";
  /** Необходимо ввести пароль **/
  EStatus["CheckPassword"] = "checkPassword";
  /** Превышен лимит ввода кода **/
  EStatus["CodeInputLimitReached"] = "codeInputLimitReached";
  /** Истекло время действия проверочного кода **/
  EStatus["CodeExpired"] = "codeExpired";
  /** Множество аккаунтов **/
  EStatus["ManyAccounts"] = "manyAccounts";
  return EStatus;
}({});